<template>
    <rkm-overlay>
        <rkm-layout-body :title="`${id ? 'Edição' : 'Cadastro'} de entrada`">
            <template v-slot:actions>
                <rkm-button
                    @click.stop="handleExit"
                    color="danger"
                >
                    Sair
                </rkm-button>

                <rkm-button
                    @click="$refs.Form.save(model.finalizada)"
                    color="primary"
                >
                    Salvar
                </rkm-button>

                <template v-if="model && !model.finalizada">
                    <rkm-button
                        @click="$refs.Form.finalizar()"
                        color="outline-success"
                    >
                        Finalizar
                    </rkm-button>
                </template>
            </template>

            <rkm-layout-content>
                <Form
                    :id="id"
                    :key="formKey"
                    @model-load="model = $event"
                    @save="handleSave"
                    ref="Form"
                />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import Form from '@/components/almoxarifado/entrada/Form'

// Vuex.
import { mapActions } from 'vuex'

export default {
    components: { Form },
    created() {

        this.setShowExitFormConfirmation()
    },
    data: () => ({
        formKey: 1,
        model: null,
    }),
    methods: {
        ...mapActions(['setShowExitFormConfirmation', 'unsetShowExitFormConfirmation']),
        handleExit() {

            this.redirectToList()
        },
        handleSave({ id }) {

            if (this.id) {

                this.formKey++
            }
            else {

                this.unsetShowExitFormConfirmation()
                this.redirectToEdit(id)
            }
        },
        redirectToList() {

            this.$router.push({ name: 'almoxarifado-entrada-index' })
        },
        redirectToEdit(id) {

            this.$router.push({ name: 'almoxarifado-entrada-edit', params: { id } })
        }
    },
    props: {
        id: { type: Number, default: null }
    },
}
</script>